import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Alert, Button, Card, CardBody } from 'reactstrap';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { Edit } from 'react-feather';

import { useUnit } from 'hooks/units/index';
import {
  CONTENT_APPROVAL,
  COURSE_STATUS,
  LIMIT_GET_LIST,
  STATUS_FILES_UNIT,
  UNIT_STATUS,
  UNIT_TYPE,
  UNIT_TYPE_COMPLETE,
  USER_ROLES,
} from 'constants/constants';
import {
  completeUnitAsync,
  refreshUnitAsync,
  resetUnitAsync,
} from 'store/units/index';
import { downloadFile, handleToastError } from 'helpers/index';
import useI18n from 'hooks/use-i18n';

import { showToastSuccess } from '@core/components/toastify/ToastTypes';
import styles from 'styles/Unit.module.scss';
import TextReply from './TextReply';
import UploadFile from './UploadFile';
import RecordAudio from './RecordAudio/RecordAudio';
import RecordVideo from './RecordVideo';
import ButtonCompleted from '../ButtonCompleted';
import YourAnswer from './YourAnswer/YourAnswer';
import ButtonAction from './ButtonAction';
import Failed from './Failed';
import { getSelectedCentre } from 'store/master';
import TrackingResultNew from './TrackingResultNew';

import unitCourseApi from '../../../../../../../api/unitCourseApi';
import { getSettingAccountAsync } from 'store/settingAccount';
import moment from 'moment';
import { getViewMode } from 'store/auth';

const AssigmentComplete = (props) => {
  const i18n = useI18n();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState('');

  const selectedCentre = useSelector(getSelectedCentre);
  const viewMode = useSelector(getViewMode);
  const { query } = useRouter();
  const unitSelected = useUnit();
  const [timer, setTimer] = useState();

  const isExpired =
    viewMode === USER_ROLES.LEARNER &&
    unitSelected?.statusFile === STATUS_FILES_UNIT.EXPIRED;

  //DisableConditon
  let isDisabled = unitSelected?.status == COURSE_STATUS.INACTIVE;

  const fileConfig = {
    AUDIO: {
      file: unitSelected?.noOfAudioFile,
      size: unitSelected?.maxAudioSize,
    },
    VIDEO: {
      file: unitSelected?.noOfVideoFile,
      size: unitSelected?.maxVideoSize,
    },
  };

  const settingAccount = useSelector(
    (state) => state.settingAccount.settingAccount,
  );

  useEffect(() => {
    dispatch(getSettingAccountAsync());
  }, []);

  async function trackUserCourseUnit() {
    const result = await unitCourseApi.trackUserCourseTest(unitSelected._id, 5);
    // checkStartTest();
    // console.log(result);
  }
  const setIntervalFunc = async () => {
    let interval = setInterval(trackUserCourseUnit, 5000);
    setTimer(interval);
  };

  useEffect(() => {
    return () => {
      for (var i = 0; i < 1000; i++) {
        window.clearInterval(i);
      }
    };
  }, [timer]);

  const handleCompleteUnit = async (data) => {
    clearInterval(timer);
    for (var i = 0; i < 1000; i++) {
      window.clearInterval(i);
    }
    try {
      let param = {};
      if (selectedCentre?._id) {
        param.centreId = selectedCentre?._id;
      }
      if (
        selectedCentre?.reviewContent ||
        selectedCentre?.reviewContent === undefined
      ) {
        param.reviewContent = true;
      }
      await dispatch(
        completeUnitAsync(data, unitSelected._id, query?.slug, param),
      );
      showToastSuccess('Submitted successfully!');
      setType('');
    } catch (e) {
      setIsLoading(false);
      handleToastError(e, i18n);
      dispatch(refreshUnitAsync(unitSelected._id));
    }
  };

  const handleResetUnit = async () => {
    try {
      let param = {};
      if (selectedCentre?._id) {
        param.centreId = selectedCentre?._id;
      }
      if (
        selectedCentre?.reviewContent ||
        selectedCentre?.reviewContent === undefined
      ) {
        param.reviewContent = true;
      }

      setIsLoading(true);
      await dispatch(resetUnitAsync(unitSelected._id, query?.slug, param));
      showToastSuccess('Reset successfully');
    } catch (e) {
      setIsLoading(false);
      handleToastError(e, i18n);
      dispatch(refreshUnitAsync(unitSelected._id));
    }
  };

  if (unitSelected?.status === UNIT_STATUS.COMPLETED) {
    return (
      <Card style={{ zIndex: 1 }}>
        <CardBody>
          <div className={classnames(styles.containerAssigment)}>
            <div className="text-center">
              <ButtonCompleted preventContinue />
              <div className="mt-2 d-flex justify-content-center">
                <div className="text-left">
                  {/* Instructor reply section (existing) */}
                  {unitSelected?.complete?.type ===
                    UNIT_TYPE_COMPLETE.INSTRUCTOR_ACCEPT && (
                    <>
                      <div>
                        <strong>Instructor Reply</strong>
                      </div>
                      <hr className="my-05" />
                      <p className="mb-0-important pb-05">
                        Grade:{' '}
                        <strong>
                          {unitSelected?.assignment?.grade?.value ??
                            unitSelected?.assignment?.grade}
                        </strong>
                      </p>
                      {unitSelected?.assignment?.comment && (
                        <p className="mb-0-important pb-05">
                          Comments:{' '}
                          <span className="whiteSpacePre">
                            {unitSelected.assignment.comment}
                          </span>
                        </p>
                      )}
                      {unitSelected?.assignment?.attachment?.length > 0 && (
                        <div className="overflow-hidden">
                          <p className="mb-0-important pb-05">
                            Instructor's marked sheet:
                          </p>
                          {unitSelected.assignment.attachment.map(
                            (item, index) => (
                              <p
                                key={index}
                                className="flex-wrap cursor-pointer mb-0-important"
                                onClick={() =>
                                  downloadFile(item?.path, item?.originalname)
                                }
                              >
                                {index + 1}.
                                <span className="text-underline pl-1 text-italic text-primary">
                                  {item?.originalname}
                                </span>
                              </p>
                            ),
                          )}
                        </div>
                      )}
                    </>
                  )}

                  {/* Simplified AI Reply Section */}
                  {unitSelected?.complete?.type ===
                    UNIT_TYPE_COMPLETE.AIAccept &&
                    typeof unitSelected?.aiReply?.total !== 'undefined' && (
                      <>
                        <div className="mt-4">
                          <strong>AI Reply</strong>
                        </div>
                        <hr className="my-05" />
                        <p className="mb-0-important pb-05">
                          Grade:{' '}
                          <strong>
                            {unitSelected?.assignment?.grade?.value ??
                              unitSelected?.assignment?.grade ??
                              '--'}
                          </strong>
                        </p>

                        {unitSelected?.assignment?.attachment?.length > 0 && (
                          <div className="overflow-hidden">
                            <p className="mb-0-important pb-05">
                              Instructor's marked sheet:
                            </p>
                            {unitSelected.assignment.attachment.map(
                              (item, index) => (
                                <p
                                  key={index}
                                  className="flex-wrap cursor-pointer mb-0-important"
                                  onClick={() =>
                                    downloadFile(item?.path, item?.originalname)
                                  }
                                >
                                  {index + 1}.
                                  <span className="text-underline pl-1 text-italic text-primary">
                                    {item?.originalname}
                                  </span>
                                </p>
                              ),
                            )}
                          </div>
                        )}
                        <p className="mb-0-important pb-05">
                          Weightage:{' '}
                          <span className="whiteSpacePre">
                            {unitSelected.aiReply.total ?? '-'}
                          </span>
                        </p>

                        <p className="mb-0-important pb-05">
                          Score:{' '}
                          <span className="whiteSpacePre">
                            {unitSelected.points
                              ? unitSelected.points + '%'
                              : '-'}
                          </span>
                        </p>

                        {unitSelected?.assignment?.comment && (
                          <p className="mb-1">
                            Comments:{' '}
                            <span className="whiteSpacePre">
                              {unitSelected.assignment.comment}
                            </span>
                          </p>
                        )}
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>

          <TrackingResultNew />
        </CardBody>
      </Card>
    );
  }

  if (unitSelected?.status === UNIT_STATUS.FAILED) {
    return (
      <Card>
        <CardBody>
          <div className={classnames(styles.containerAssigment)}>
            <Failed />
          </div>
          <TrackingResultNew />
        </CardBody>
      </Card>
    );
  }

  if (unitSelected?.status === UNIT_STATUS.PENDING) {
    return (
      <Card style={{ zIndex: 1 }}>
        <CardBody>
          <div className={classnames(styles.containerAssigment)}>
            <div className="text-center">
              <Button.Ripple disabled>
                Pending reply from Instructor
              </Button.Ripple>
              <div className="d-flex mt-2">
                <YourAnswer />
                <ButtonAction
                  icon={<Edit />}
                  text="Reset your answer"
                  onClick={handleResetUnit}
                  disabled={isLoading}
                />
              </div>
            </div>
          </div>
          <TrackingResultNew />
        </CardBody>
      </Card>
    );
  }
  return (
    <Card style={{ zIndex: 1 }}>
      <CardBody>
        {unitSelected?.assignment?.reasonReset ? (
          <>
            <Alert color="dark">
              <div className="alert-body whiteSpacePre">
                <strong className="d-block">Reasons for resubmission</strong>
              </div>
            </Alert>

            <div className="mb-2 ml-1">
              {unitSelected?.assignment?.reasonReset}
            </div>
            <hr className="my-05" />
          </>
        ) : null}
        <p className="text-center mb-0-important">
          {type === 'FILE' &&
            `Maximum ${
              unitSelected?.noOfFiles
                ? unitSelected?.noOfFiles
                : settingAccount
                ? parseInt(settingAccount?.submissionLimit)
                : 1
            } file is allowed. The file has a maximum size of ${
              unitSelected?.maxFileSize ? unitSelected?.maxFileSize : '5'
            }MB.`}

          {type &&
            (type === 'AUDIO' || type === 'VIDEO') &&
            `Maximum ${fileConfig[type].file} file is allowed. The file has a maximum size of ${fileConfig[type].size} MB.`}
        </p>
        {isExpired ? (
          <p style={{ color: 'rgb(252, 52, 52)' }} className="text-center">
            This lesson expired on{' '}
            <strong>
              {moment(unitSelected?.time?.end).format('MMMM Do YYYY, h:mm A')}
            </strong>{' '}
          </p>
        ) : (
          <div
            className={classnames(styles.containerAssigment, type && 'd-block')}
          >
            <TextReply
              type={type}
              setType={setType}
              setIntervalFunc={setIntervalFunc}
              onSubmitCompleteUnit={handleCompleteUnit}
            />
            <UploadFile
              isDisabled={isDisabled}
              type={type}
              setType={setType}
              setIntervalFunc={setIntervalFunc}
              allowMultipleUploads={true}
              maxSize={
                unitSelected?.maxFileSize ? unitSelected?.maxFileSize : 5
              }
              limit={
                unitSelected?.noOfFiles
                  ? unitSelected?.noOfFiles
                  : settingAccount
                  ? parseInt(settingAccount?.submissionLimit)
                  : 1
              }
              onSubmitCompleteUnit={handleCompleteUnit}
            />
            <RecordVideo
              isDisabled={isDisabled}
              type={type}
              setType={setType}
              setIntervalFunc={setIntervalFunc}
              onSubmitCompleteUnit={handleCompleteUnit}
            />
            <RecordAudio
              isDisabled={isDisabled}
              type={type}
              setType={setType}
              setIntervalFunc={setIntervalFunc}
              onSubmitCompleteUnit={handleCompleteUnit}
            />
          </div>
        )}

        <TrackingResultNew />
      </CardBody>
    </Card>
  );
};

export default AssigmentComplete;
